/**
 * klaw 공통 타입 정의 — 법제처 Open API 응답 구조 기반
 */

export type LawType = 'law' | 'prec' | 'admrul' | 'ordin' | 'cnstc' | 'intprt'

export const LAW_TYPE_LABELS: Record<LawType, string> = {
  law:    '법령',
  prec:   '판례',
  admrul: '행정규칙',
  ordin:  '자치법규',
  cnstc:  '헌재결정',
  intprt: '법령해석례',
}

export const LAW_TYPE_COLORS: Record<LawType, string> = {
  law:    'bg-blue-100 text-blue-700',
  prec:   'bg-amber-100 text-amber-700',
  admrul: 'bg-green-100 text-green-700',
  ordin:  'bg-purple-100 text-purple-700',
  cnstc:  'bg-red-100 text-red-700',
  intprt: 'bg-gray-100 text-gray-700',
}

// 검색 결과 아이템 — lawSearch.do 응답 기준 (언더스코어 없음)
export interface LawSearchItem {
  법령일련번호?: string
  법령명한글?: string       // 검색: 언더스코어 없음
  소관부처명?: string
  시행일자?: string
  공포일자?: string
  법령구분명?: string
  판례정보일련번호?: string
  사건명?: string
  사건번호?: string
  선고일자?: string
  법원명?: string
  행정규칙일련번호?: string
  행정규칙명?: string
  발령기관명?: string
}

export interface LawSearchResponse {
  LawSearch?: {
    totalCnt: string | number
    page: string | number
    law?: LawSearchItem[]
  }
}

export interface SearchResult {
  id: string
  title: string
  subtitle?: string
  type: LawType
  date?: string
  ministry?: string
  raw: LawSearchItem
}

// 법령 전문 — lawService.do 응답 기준
export interface LawDetail {
  법령?: {
    기본정보?: {
      법령명_한글: string
      법령구분명: string
      소관부처?: { content: string; 소관부처코드?: string } | string
      공포일자: string
      시행일자: string
    }
    조문?: {
      조문단위: LawArticle | LawArticle[]
    }
  }
}

export interface LawArticle {
  조문번호: string
  조문제목?: string
  조문내용?: string
  조문여부?: string
  항?: LawParagraph | LawParagraph[]
}

export interface LawParagraph {
  항번호: string
  항내용: string
  호?: LawSubItem | LawSubItem[]
}

export interface LawSubItem {
  호번호: string
  호내용: string
}

export interface SearchState {
  query: string
  type: LawType | 'all'
  results: SearchResult[]
  isLoading: boolean
  error: string | null
  totalCount: number
  page: number
}
